import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

export const allComputersResource = {
    display_name: 'All resources',
    guid: 'all_computers_guid',
    services: [],
    excluded: false,
    type: AD_ENTITY_TYPES.SERVER,
    name: 'All resources'
};

export const unresolvedResources = {
    display_name: 'Unresolved resources',
    guid: 'unresolved_resources_guid',
    services: [],
    excluded: false,
    type: AD_ENTITY_TYPES.SERVER,
    name: 'Unresolved resources'
}